module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg4": ""
    }
  }, [(_vm.resultado) ? _c('resultado-card', {
    attrs: {
      "resultado": _vm.resultado
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6e2edc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultadoPaciente.vue
// module id = 362
// module chunks = 1